type PanelEntry = {
  id: string;
  zIndex: number;
  onClose?: () => void;
};

let nextZIndex = 10000;
const panels = new Map<string, PanelEntry>();

export function registerFloatingPanel(id: string, baseZIndex: number, onClose?: () => void): () => void {
  const entry: PanelEntry = { id, zIndex: Math.max(baseZIndex, nextZIndex), onClose };
  panels.set(id, entry);
  nextZIndex = entry.zIndex + 1;

  return () => {
    panels.delete(id);
  };
}

export function focusFloatingPanel(id: string): number {
  const entry = panels.get(id);
  if (!entry) return nextZIndex;
  nextZIndex += 1;
  entry.zIndex = nextZIndex;
  panels.set(id, entry);
  return entry.zIndex;
}

export function getFloatingPanelZIndex(id: string, baseZIndex: number): number {
  return panels.get(id)?.zIndex ?? baseZIndex;
}

export function closeTopmostFloatingPanel(): boolean {
  let top: PanelEntry | null = null;
  for (const entry of panels.values()) {
    if (!top || entry.zIndex > top.zIndex) top = entry;
  }
  if (top?.onClose) {
    top.onClose();
    return true;
  }
  return false;
}
